import { Injectable } from "@angular/core";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Subscription, Observable } from "rxjs";
import { AppMensajeModel } from "src/app/shared/models/mensajes/mensajes.model";
import { formatUrl } from "src/app/shared/utilities/utils";
import { GetMensajesModel } from "src/app/shared/models/chat/getMensajes.model";

@Injectable({
    providedIn: "root",
})
export class MensajesService {
    // chatSubject: BehaviorSubject<AppMensajeModel[]> = new BehaviorSubject<AppMensajeModel[]>([]);
    chatSubject: BehaviorSubject<GetMensajesModel[]> = new BehaviorSubject<
        GetMensajesModel[]
    >([]);

    subchat: Subscription;
    intervalChat;
    endpoint: string = "Mensaje";
    constructor(
        private auth: AuthenticationService,
        private http: HttpClient
    ) {}

    initsubMensajeria() {
        this.callGet();
        this.initIntervalMensajeria();
    }

    initIntervalMensajeria() {
        this.callGet();
        this.intervalChat = setInterval(() => {
            this.callGet();
        }, 3000);
    }

    callGet() {
        this.getMessajes()
            .toPromise()
            .then((res) => {
                this.chatSubject.next(res);
            });
    }

    obChatsubs() {
        return this.chatSubject.asObservable();
    }

    get urlComms(): string {
        return `${this.auth.urlComms}`;
    }

    getMessajes(): Observable<GetMensajesModel[]> {

        var filter = {
            skip: 0,
            take: 10,
            userId: this.auth.currentUserValue._id,
        };
        var url = this.urlComms + "Mensajeria/GetMensajesByIdChronological";
        return this.http.post<GetMensajesModel[]>(url, filter);
    }

    // getMessajes() : Observable<AppMensajeModel[]>{
    //   var url = formatUrl(this.auth,this.endpoint,`getMensajesConductor?codemple=${this.auth.currentUserValue.codempleado}`);
    //   return this.http.get<AppMensajeModel[]>(url)
    // }

    sendMessaje(data): Observable<boolean> {
        var url = formatUrl(this.auth, this.endpoint, "postMensajeConductor");
        return this.http.post<boolean>(url, data);
    }

    setLeido(id_mensaje, anyo) {
        var url = formatUrl(this.auth, this.endpoint, "postLeido");
        return this.http.post<void>(url, {
            Id_mensaje: id_mensaje,
            Id_anyo: anyo,
            Fecha_leido: new Date(),
        });
    }

    closeSubMensajeria() {
        clearInterval(this.intervalChat);
        this.subchat?.unsubscribe();
        this.chatSubject.next([]);
    }
}
